import axiosIns from './ajax'
// import { Toast } from 'vant'
// import axios from 'axios'

// axios二次封装使用  函数用法
// export const getBaseCategoryList = ()=>axiosIns.get("/api/product/getBaseCategoryList")

// 话题推荐的接口： https://fosunapi.focuth.com/circle/topic/list   GET
export const getTopicHotList = (user) => {
  return axiosIns({
    url: '/circle/topic/list',
    params: {
      user
    }
  })
}

// nv采集接口 /api/event/tracking/uv

export const upUvData = (result) => {
  return axiosIns({
    url: '/api/event/tracking/uv',
    method: 'POST',
    data: result
  })
}
// 首页轮播展示API
export const getActivateVote = (mobile) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/questionnaire/vote/list',
    method: 'get',
    params: {
      page: 1,
      size: 100,
      mobile,
      state: 'open',
      submit_state: 0
    }
  })
}
// 问卷详情
export const getVoteDetail = (id, mobile) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/questionnaire/vote/detail',
    method: 'GET',
    params: {
      mobile,
      questionnaire_id: id
    }
  })
}

// 2024-3-1 新增权限接口
export const getESGpermission = (result) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/users/permission',
    method: 'POST',
    data: result
  })
}

// 获取问卷列表
export const getQuestionnaireResultList = (page, size, mobile, keyword, num, state) => {
  return axiosIns({
    url: `https://circle.fosun.com/api/v1/circle/questionnaire/vote/list${keyword ? '?keyword=' + keyword : ''}`,
    method: 'GET',
    params: {
      page,
      size,
      mobile,
      is_vote_admin: num,
      state
    }
  })
}

// 获取问卷结果分析详情
export const getQuestionnaireResiltDetail = (mobile, id) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/questionnaire/statistics/result',
    method: 'GET',
    params: {
      questionnaire_id: id,
      mobile
    }
  })
}

// 保存填写问卷数据 https://circle.fosun.com/api/v1/circle/questionnaire/vote/save?mobile=19121517854
export const submitQuestionnaire = (mobile, result) => {
  return axiosIns({
    url: `https://circle.fosun.com/api/v1/circle/questionnaire/vote/save?mobile=${mobile}`,
    method: 'POST',
    data: result
  })
}

// 用于判断用户是否填写完当前问卷 http://127.0.0.1:8000/api/v1/circle/questionnaire/vote/done
export const getVoteIsDone = (mobile, id) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/questionnaire/vote/done',
    method: 'GET',
    params: {
      questionnaire_id: id,
      mobile
    }
  })
}

// 用于设置用户已填写问卷
// export const setVoteDone = (mobile, id) => axiosIns.post(`/api/v1/circle/questionnaire/vote/done?mobile=${mobile}&questionnaire_id=${id}`)

export const setVoteDone = (result) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/questionnaire/vote/done',
    method: 'POST',
    data: result,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
  })
}

// /api/v1/circle/award/user/record/list 获取奖品列表
export const getRecordList = (mobile) => {
  return axiosIns({
    url: 'https://fosun.focuth.com/v2/api/v1/circle/award/user/record/list',
    method: 'GET',
    params: {
      mobile
    }
  })
}
// 设置收货地址 /api/v1/circle/award/order/address/add
export const setAddress = (phone, result) => {
  return axiosIns({
    url: 'https://fosun.focuth.com/v2/api/v1/circle/award/order/address/add',
    method: 'POST',
    data: result,
    params: {
      mobile: phone
    }
  })
}
// 视频上传 https://fosunapi.focuth.com/api/v1/circle/aliyun/oss/video/upload
export const upvideo = (file) => {
  const formData = new FormData()
  formData.append('video', file)
  return axiosIns({
    url: '/api/v1/circle/aliyun/oss/video/upload',
    method: 'POST',
    data: formData
  })
}

// /api/v1/circle/aliyun/oss/anti-spam/check 视频上传成功后通知进行视频元素审查
export const videoExamine = (data) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/aliyun/oss/anti-spam/check',
    method: 'get',
    params: data
  })
}

// 点赞评论通知接口 https://circle.fosun.com/api/v1/circle/message/action/log/notify
export const messageInform = (data) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/message/action/log/notify',
    method: 'post',
    data
  })
}

// 获取圈子列表 https://fosunapi.focuth.com/circle/circle/menu/list?mobile=18715124118
export const getMenuList = (data) => {
  return axiosIns({
    url: '/circle/circle/menu/list',
    method: 'GET',
    data
  })
}
export const getTopicollections = () => {
  return axiosIns({
    url: '/circle/topic/collections/list',
    method: 'GET'
  })
}

// 认人事专区话题列表搜索  /circle/tag?tagType=0&tagName=复星123
export const getTopicBYstring = (str) => {
  return axiosIns({
    url: `/circle/tag?tagType=0&tagName=${str}`,
    method: 'GET'
    // data: {
    //   tagType: 0,
    //   tagName: str
    // }
  })
}

// https://circle.fosun.com/api/v1/circle/annual/summary?mobile=xxxxxxx
export const getaAnnualSummary = (mobile) => {
  return axiosIns({
    // url: `https://circle.fosun.com/api/v1/circle/annual/summary?mobile=${mobile}`,
    url: `https://circle.fosun.com/api/v1/circle/annual/summary?mobile=${mobile}`,
    method: 'GET'
  })
}

// https://circle.fosun.com/api/v1/circle/bbs/user/search?mobile=13174460660&key=%E5%BC%A0
export const getUsersByName = (data) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/bbs/user/search',
    method: 'GET',
    params: data
  })
}
// 获取用户Token
export const getUserToken = (data) => {
  return axiosIns({
    url: '/user/token',
    method: 'POST',
    data
  })
}
// 获取推送海报
export const getPushPoster = (data) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/circle/aliyun/static-file/detail',
    method: 'get',
    params: {
      ...data
    }
  })
}
// 获取中奖推送页中奖详情
export const getWinnerDetail = (data) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/lottery/lucky/winner/detail',
    method: 'get',
    params: {
      ...data
    }
  })
}

// 获取ESG ID对应的任务
export const getESGdetail = (data) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/esg/task/action/tips',
    method: 'get',
    params: {
      ...data
    }
  })
}

// 跳转ESG 记录点击记录
export const getESGTopic = (data) => {
  return axiosIns({
    url: 'https://circle.fosun.com/api/v1/esg/report/click/statistics',
    method: 'get',
    params: {
      ...data
    }
  })
}
